import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudEquipoAsignarDocumentoModel } from "../../interfaces/solicitud/equipos/ISolicitudEquipoAsignarDocumentoModel";
import { ISolicitudEquipoModel } from "../../interfaces/solicitud/ISolicitudEquipoModel";

export class SolicitudEquipoAsignarDocumentoModel implements ISolicitudEquipoAsignarDocumentoModel {
    equipos: ISolicitudEquipoModel[];
    documento?: ISolicitudDocumentoModel;

    constructor(){
        this.equipos = new Array<ISolicitudEquipoModel>();
    }
}